import { APValidator } from '../../../../global/validators/ap_validator';
import { PreviewTermPlanModel } from '../models/preview_term_plan_model';

export class VerifyPreviewPlanData {
  constructor(private ngPreviewTermPlanModel: PreviewTermPlanModel, private ngAPValidator: APValidator) {}

  verify() {
    const plannedCourseValidator = this.ngAPValidator.validate(
      this.ngPreviewTermPlanModel.read().planned_courses,
      {
        term: {
          key: 'term.id',
          type: 'ONE_TO_ONE',
          data: this.ngPreviewTermPlanModel.read().student_planned_terms
        }
      },
      'Quick Plan API: Planned Course data verification failed'
    );

    const plannedCourseGroupValidator = this.ngAPValidator.validate(
      this.ngPreviewTermPlanModel.read().planned_course_groups,
      {
        term: {
          key: 'term.id',
          type: 'ONE_TO_ONE',
          data: this.ngPreviewTermPlanModel.read().student_planned_terms
        }
      },
      'Quick Plan API: Planned Course Group data verification failed'
    );

    return Promise.all([plannedCourseValidator, plannedCourseGroupValidator]);
  }
}

angular.module('capability-ng-academic-planner').service('ngAPVerifyPreviewPlanData', VerifyPreviewPlanData);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/validators/verify_preview_plan_data.ts